<app-menu-toggle
  tooltip="Auto rotate"
  icon="rotate"
  [active]="autoRotate"
  (click)="toggleAutoRotate()"
>
</app-menu-toggle>
